import React, { type ReactNode } from 'react';

import './textLink.scss';

/**
 * TextLink
 */
const TextLink = (props: { onClick: () => void; children: ReactNode }) => {
  const { onClick, children } = props;
  return (
    <span className="link-ele" onClick={onClick}>
      {children}
    </span>
  );
};

export default TextLink;
